import {Observable} from "rxjs";
import {map, take} from "rxjs/operators";
import {CheckoutUtil} from "../../checkout-util";
import {Injectable} from "@angular/core";
import {UsanaObject} from "../../../modules/usana-object";
import {Apollo} from "apollo-angular";
import {LoggerService} from "../../../modules/common/logger.service";
import {
    GetDashboardSharePrep,
    GetShopSessionDashboard,
    GetShopSessionDashboardShare,
    SaveFirstShopSessionEvent,
    SaveShopSessionEvent
} from "./gql-shop-session";
import {IShopSessionEventInput} from "../../../modules/session/shop-session-models";

@Injectable({
    providedIn: 'root'
})
export class GqlShopSessionService extends UsanaObject {

    constructor(private apollo: Apollo,
                loggerService: LoggerService) {
        super(loggerService);
    }

    saveFirstShopSessionEvent(): Observable<any> {
        return this.apollo
            .mutate({
                mutation: SaveFirstShopSessionEvent,
                variables: {referer: document.referrer}
            })
            .pipe(take(1), map((data: any) => {
                return CheckoutUtil.handleApolloResponse(data, (d) => d.data.saveFirstShopSessionEvent);
            }));

    }

    saveShopSessionEvent(shopSessionEventInput: IShopSessionEventInput): Observable<any> {
        return this.apollo
            .mutate({
                mutation: SaveShopSessionEvent,
                variables: {shopSessionEventInput}
            })
            .pipe(take(1), map((data: any) => {
                return CheckoutUtil.handleApolloResponse(data, (d) => d.data.saveShopSessionEvent);
            }));

    }

    getShopSessionDashboard(): Observable<any> {
        return this.apollo
            .watchQuery({
                query: GetShopSessionDashboard
            })
            .valueChanges.pipe(take(1), map((data: any) => {
                return CheckoutUtil.handleApolloResponse(data, (d) => d.data.getShopSessionDashboard);
            }));

    }

    getShopSessionDashboardShare(dashboardTotalsFilter: any): Observable<any> {
        return this.apollo
            .watchQuery({
                query: GetShopSessionDashboardShare,
                variables: {dashboardTotalsFilter}
            })
            .valueChanges.pipe(take(1), map((data: any) => {
                return CheckoutUtil.handleApolloResponse(data, (d) => d.data.getShopSessionDashboardShare);
            }));

    }

    getDashboardSharePrep(secondsBack: number): Observable<any> {
        return this.apollo
            .watchQuery({
                query: GetDashboardSharePrep,
                variables: {secondsBack}
            })
            .valueChanges.pipe(take(1), map((data: any) => {
                return CheckoutUtil.handleApolloResponse(data, (d) => d.data.getDashboardSharePrep);
            }));

    }
}
